<template>
    <div class="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-charcoal-800">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto w-64" src="@/assets/img/custodian-community-logo.png" alt="TAP"/>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-6 px-4 sm:px-6">
                <div class="bg-red-200 p-4 mb-4" v-show="errorMessage">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-xs leading-5 text-red-800">
                                {{ errorMessage }}
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="bg-green-200 p-4 mb-4"  v-show="successMessage">
                    <div class="flex">
                        <h3 class="text-xs leading-5 text-green-800">
                            {{ successMessage }}
                        </h3>
                    </div>
                </div>
                <ValidationObserver v-slot="{ handleSubmit }" v-if="!enterCode">
                    <form @submit.prevent="handleSubmit(getCode)">
                        <div class="relative">
                            <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                                Email
                            </label>
                            <div class="mt-1">
                                <ValidationProvider name="Email" mode="lazy" rules="required|email" v-slot="{ errors }" tag="div">
                                    <input id="email" type="email" v-model="email" class="appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                                    <span class="text-xs text-red-500 absolute">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="mt-6">
                            <span class="block w-full rounded-md shadow-sm">
                                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-default-500 hover:bg-default-600 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out" :disabled="submitted">
                                    <svg width="22" height="22" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff" class="mr-2" v-show="submitted">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform
                                                        attributeName="transform"
                                                        type="rotate"
                                                        from="0 18 18"
                                                        to="360 18 18"
                                                        dur="1s"
                                                        repeatCount="indefinite"
                                                    />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                    Get Code
                                </button>
                             </span>
                        </div>
                    </form>
                </ValidationObserver>
                <ValidationObserver v-slot="{ handleSubmit }" v-if="enterCode">
                    <form @submit.prevent="handleSubmit(authenticate)">
                        <div class="relative">
                            <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                                Code
                            </label>
                            <div class="mt-1">
                                <ValidationProvider name="Code" v-slot="{ errors }" tag="div">
                                    <input id="code" type="text" v-model="code" class="appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                                    <span class="text-xs text-red-500 absolute">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="mt-6">
                            <span class="block w-full rounded-md shadow-sm">
                                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-default-500 hover:bg-default-600 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out" :disabled="submitted">
                                    <svg width="22" height="22" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff" class="mr-2" v-show="submitted">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform
                                                        attributeName="transform"
                                                        type="rotate"
                                                        from="0 18 18"
                                                        to="360 18 18"
                                                        dur="1s"
                                                        repeatCount="indefinite"
                                                    />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                    Sign In
                                </button>
                             </span>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md text-center text-charcoal-400 text-xs">
            <p>Copyright © {{ year }} <a href="https://www.webmanage.com" class="no-underline" target="_blank">WebManage</a>. All Rights Reserved.</p>
        </div>
        <notifications group="main" position="bottom right" />
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Login",
        data: () => {
            return {
                errorMessage: '',
                successMessage: '',
                submitted: false,
                forgot: false,
                email: process.env.VUE_APP_USER,
                forgotEmail: '',
                year: (new Date()).getFullYear(),
                enterCode: false,
                code: null,
            }
        },
        methods: {
            authenticate: function(){
                this.submitted = true;
                this.errorMessage = '';
                this.successMessage = '';

                const { email, code } = this;

                this.$store.dispatch('AUTH_REQUEST', { email, code }).then(() => {
                    this.submitted = false;
                    this.$router.push('dashboard');
                }).catch(() => {
                    this.submitted = false;
                    this.errorMessage = 'Unable to login, please try again.';
                });
            },
            getCode: function(){
                this.submitted = true;
                this.errorMessage = '';

                axios.post(process.env.VUE_APP_API_URL + '/get-code', { email: this.email }).then(() => {
                    this.enterCode = true;
                    this.submitted = false;
                    this.successMessage = 'If your email is registered, you will receive a code shortly.';
                }).catch((error) => {
                    console.error(error);
                    this.submitted = false;
                    this.errorMessage = 'Invalid code, please try again.';
                    this.enterCode = false;
                });
            },
        },
    }
</script>

<style scoped>

</style>
